import { render, staticRenderFns } from "./SimpleTag.vue?vue&type=template&id=8903515c"
import script from "./SimpleTag.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimpleTag.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports